import React from 'react';
import { InputProps } from '@material-ui/core/Input';
import {
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
} from '@material-ui/core';
import StatusIcon from '../password-error/StatusIcon';
import useStyles from './styles';
import { PromotionCode } from '../../types/items';
import useFormInputStyles from '../form-input/styles';

type Props = Omit<InputProps, 'classes'> & {
  promotionCode: PromotionCode;
  label: string;
};

const FormInformativePromotionCodeInput = ({ promotionCode, label }: Props) => {
  const classes = useStyles();
  const inputClasses = useFormInputStyles();

  return (
    <div>
      <FormControl
        fullWidth
        disabled
        className={`${classes.promoField} ${classes.uppercaseField}`}
        classes={{
          root: inputClasses.root,
        }}
      >
        {label && (
          <InputLabel
            classes={{
              root: inputClasses.labelRoot,
              focused: inputClasses.focused,
            }}
          >
            {label}
          </InputLabel>
        )}
        <Input
          disabled
          classes={{
            input: inputClasses.input,
            underline: inputClasses.inputUnderline,
            focused: inputClasses.focused,
            disabled: inputClasses.disabled,
          }}
          value={promotionCode.code}
        />
      </FormControl>
      {promotionCode && (
        <FormHelperText className={`${classes.helperText} ${classes.helperTextSuccess}`}>
          <StatusIcon state className={classes.icon} />
          Promo Code accepted for {promotionCode.summary}
        </FormHelperText>
      )}
    </div>
  );
};

export default FormInformativePromotionCodeInput;
